// Couleur d'identification d'un modèle récursif (« Poste de travail »,
// « Tenue »…). Le même modèle doit porter la même couleur partout où il
// apparaît : arbre des sections (panel gauche) et bandeau de contexte (panel
// droit). C'est ce qui permet de relier les deux vues sans les lire.
//
// Couleur dérivée du nom du modèle, pas d'un index de liste : les modèles
// disponibles varient d'une convention à l'autre (recursiveSectionRelationships),
// un index donnerait une couleur différente au même modèle selon le document.
// Palette volontairement contrastée entre elle et lisible sur fond clair.
const MODEL_COLORS = [
  '#2F6FD0',
  '#0E9F73',
  '#C2703A',
  '#7D53C9',
  '#C0417A',
  '#1E93AE',
  '#8A8F2C',
];

export function recursiveModelColor(modelName) {
  if (!modelName) return null;
  // djb2 tronqué : stable d'une session à l'autre, contrairement à un hash
  // dépendant de l'ordre d'insertion.
  let hash = 5381;
  for (let i = 0; i < modelName.length; i += 1) {
    hash = ((hash * 33) ^ modelName.charCodeAt(i)) >>> 0;
  }
  return MODEL_COLORS[hash % MODEL_COLORS.length];
}
